import React from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Select,
  Textarea,
} from '@chakra-ui/react';
import CountrySelect from '../common/CountrySelect';

const OrganizationBillingFields = ({
  values,
  onChange,
  onBillingSameAsOrgChange,
  sectionBg,
  showBillingNotes = true,
  labels = {},
}) => {
  const l = (key, fallback) => labels[key] || fallback;

  return (
    <Box bg={sectionBg} p={4} borderRadius="md">
      <Heading as="h4" size="sm" mb={2}>
        {l('billingInfo', 'Billing Information')}
      </Heading>

      <FormControl mt={3}>
        <FormLabel>{l('billingSameAsOrg', 'Billing same as school')}</FormLabel>
        <Select
          name="billing_same_as_org"
          value={values.billing_same_as_org ? 'true' : 'false'}
          onChange={(event) => onBillingSameAsOrgChange(event.target.value === 'true')}
        >
          <option value="true">{l('yes', 'Yes')}</option>
          <option value="false">{l('no', 'No')}</option>
        </Select>
      </FormControl>

      {!values.billing_same_as_org ? (
        <>
          <FormControl mt={3}>
            <FormLabel>{l('billingAddress', 'Billing address')}</FormLabel>
            <Input name="billing_address" value={values.billing_address || ''} onChange={onChange} />
          </FormControl>
          <FormControl mt={3}>
            <FormLabel>{l('billingCity', 'Billing city')}</FormLabel>
            <Input name="billing_city" value={values.billing_city || ''} onChange={onChange} />
          </FormControl>
          <FormControl mt={3}>
            <FormLabel>{l('billingState', 'Billing state')}</FormLabel>
            <Input name="billing_state" value={values.billing_state || ''} onChange={onChange} />
          </FormControl>
          <FormControl mt={3}>
            <FormLabel>{l('billingZip', 'Billing zip')}</FormLabel>
            <Input name="billing_zip" value={values.billing_zip || ''} onChange={onChange} />
          </FormControl>
          <FormControl mt={3}>
            <FormLabel>{l('billingCountry', 'Billing country')}</FormLabel>
            <CountrySelect
              name="billing_country"
              value={values.billing_country || ''}
              onChange={onChange}
              placeholder={l('billingCountryPlaceholder', 'Select billing country')}
            />
          </FormControl>
        </>
      ) : null}

      <FormControl mt={3}>
        <FormLabel>{l('billingCompanyName', 'Billing company name')}</FormLabel>
        <Input name="billing_company_name" value={values.billing_company_name || ''} onChange={onChange} />
      </FormControl>

      <FormControl mt={3}>
        <FormLabel>{l('vatOrTaxNumber', 'VAT or tax number')}</FormLabel>
        <Input name="vat_or_tax_number" value={values.vat_or_tax_number || ''} onChange={onChange} />
      </FormControl>

      <FormControl mt={3}>
        <FormLabel>{l('organisationsnummer', 'Organisationsnummer')}</FormLabel>
        <Input name="organisationsnummer" value={values.organisationsnummer || ''} onChange={onChange} />
      </FormControl>

      <FormControl mt={3}>
        <FormLabel>{l('currency', 'Currency')}</FormLabel>
        <Input name="currency" value={values.currency || ''} onChange={onChange} placeholder="e.g. USD, EUR, SEK" />
      </FormControl>

      <FormControl mt={3}>
        <FormLabel>{l('billingMethod', 'Billing method')}</FormLabel>
        <Select name="billing_method" value={values.billing_method || ''} onChange={onChange}>
          <option value="">{l('select', 'Select')}</option>
          <option value="invoice_email">{l('billingMethodInvoice', 'Invoice by email')}</option>
          <option value="direct_debit">{l('billingMethodDebit', 'Direct debit')}</option>
          <option value="credit_card">{l('billingMethodCard', 'Credit card')}</option>
          <option value="edi_peppol">{l('billingMethodPeppol', 'EDI/Peppol')}</option>
          <option value="other">{l('other', 'Other')}</option>
        </Select>
      </FormControl>

      {values.billing_method === 'invoice_email' ? (
        <FormControl mt={3}>
          <FormLabel>{l('billingEmail', 'Billing email')}</FormLabel>
          <Input name="billing_email" value={values.billing_email || ''} onChange={onChange} />
        </FormControl>
      ) : null}

      {values.billing_method === 'edi_peppol' ? (
        <>
          <FormControl mt={3}>
            <FormLabel>{l('peppol', 'Peppol')}</FormLabel>
            <Input name="peppol" value={values.peppol || ''} onChange={onChange} />
          </FormControl>
          <FormControl mt={3}>
            <FormLabel>{l('gln', 'GLN')}</FormLabel>
            <Input name="gln" value={values.gln || ''} onChange={onChange} />
          </FormControl>
        </>
      ) : null}

      {values.billing_method === 'other' ? (
        <FormControl mt={3}>
          <FormLabel>{l('billingMethodOther', 'Other billing method')}</FormLabel>
          <Input name="billing_method_other" value={values.billing_method_other || ''} onChange={onChange} />
        </FormControl>
      ) : null}

      <FormControl mt={3}>
        <FormLabel>{l('referencePerson', 'Reference person')}</FormLabel>
        <Input name="reference_person" value={values.reference_person || ''} onChange={onChange} />
      </FormControl>

      <FormControl mt={3}>
        <FormLabel>{l('referenceNumber', 'Reference number')}</FormLabel>
        <Input name="reference_number" value={values.reference_number || ''} onChange={onChange} />
      </FormControl>

      <FormControl mt={3}>
        <FormLabel>{l('costCenter', 'Cost center')}</FormLabel>
        <Input name="cost_center" value={values.cost_center || ''} onChange={onChange} />
      </FormControl>

      {showBillingNotes ? (
        <FormControl mt={3}>
          <FormLabel>{l('billingNotes', 'Billing notes')}</FormLabel>
          <Textarea
            name="billing_notes"
            value={values.billing_notes || ''}
            onChange={onChange}
            placeholder={l('billingNotesPlaceholder', 'Add billing notes')}
          />
        </FormControl>
      ) : null}
    </Box>
  );
};

export default OrganizationBillingFields;
